export interface INameSpecifiable {
  name: string;
}

export function instanceOfINameSpecifiable(instance: any): instance is INameSpecifiable {
  return instance
    && (instance.name !== undefined);
}
